import React from 'react'
import { Card, Modal, Row } from 'antd'
import _ from 'lodash'
import { MaterialItem } from '../../../styles/shared.style'

const PickMaterial = (props) => {
  const {
    visible,
    categories,
    onClose,
    materialPick,
    setMaterialPick,
    productLinkList
  } = props

  const renderItemActive = (item) => {
    let active = false

    if (materialPick !== null) {
      if (item.id === materialPick.id) {
        active = true
      }
    }

    return active
  }

  const renderItemDisabled = (item) => {
    let disabled = false

    for (const product of productLinkList) {
      if (item.id === product.id) {
        disabled = true
      }
    }

    return disabled
  }

  function onClickItem(material) {
    setMaterialPick(material)
  }

  function onOk() {
    onClose()
  }

  return (
    <Modal
      title="เลือกวัสดุ"
      visible={visible}
      destroyOnClose
      width={1000}
      onOk={onOk}
      onCancel={onClose}>
      <Card style={{ marginTop: 10, height: 450, overflowY: 'scroll' }}>
        {!_.isEmpty(categories) &&
          categories.map((item, index) => {
            return (
              <Row type="flex" key={index}>
                <Row style={{ width: '100%' }}>
                  <span style={{ color: 'green', fontSize: 18 }}>
                    {item.categoryName}
                  </span>
                </Row>
                {item.materialList.map((material, idx) => {
                  return (
                    <MaterialItem
                      key={idx}
                      disabled={renderItemDisabled(material)}
                      active={renderItemActive(material)}
                      onClick={() => onClickItem(material)}>
                      {material.name}
                    </MaterialItem>
                  )
                })}
              </Row>
            )
          })}
      </Card>
    </Modal>
  )
}

export default PickMaterial
